<div class="container-fluid h-100">
  <div class="row h-100">
    <div class="col section-content missing-permissions">
      <div class="content-container">
        <div class="icon-circle">
          <i class="bi bi-exclamation-circle"></i>
        </div>
        <h1>Missing permissions</h1>
        <h3>Oops! Looks like you don't have permission to access this page.</h3>

        <div class="row permission-buttons">
          <div class="col">
            <button type="button" class="btn button-back" (click)="back()">
              <i class="bi bi-arrow-left"></i> Go Back
            </button>
          </div>
          <div class="col">
            <button type="button" class="btn button-primary" (click)="home()">Take me home</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
